import { ADDRESS_LIST } from "../actions/customerTypes";
import { ALL_MENU, BEST_SELLERS, COMBO_DETAIL, COUPON_DETAILS, COUPON_FREE_DELIVERY, CROSS_SELL, HOME_GROUPS, ITEM_DETAIL, LANDING_BANNERS, REMOVE_ORDER_DATA, TOP_DEALS,WEB_APP_THEME } from "../actions/menuTypes";

const initialState: any = {
    landingBanners: [] || "",
    homeGroups: [] || "",
    topDeals: null,
    bestSellers: [] || "",
    crossSellItems: [] || "",
    itemData: {},
    comboData: {},
    orderData: "",
    orderList: [],
    groups: [] || '',
    groupsData: [] || '',
    orderDetail: [] || '',
    lastFiveOrders: [] || '',
    couponDetails: null,
    couponFreeDelivery: 0

}
const menuReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ALL_MENU:
            return {
                ...state,
                groups: action.groups,
                groupsData: action.groupsData
            }
        case LANDING_BANNERS:
            return {
                ...state,
                landingBanners: action.payload
            }
        case HOME_GROUPS:
            return {
                ...state,
                homeGroups: action.payload
            }
        case ITEM_DETAIL:
            return {
                ...state,
                itemData: action.payload
            };
        case COMBO_DETAIL:
            return {
                ...state,
                comboData: action.payload,
            };
        case TOP_DEALS:
            return {
                ...state,
                topDeals: action.payload
            }
        case BEST_SELLERS:
            return {
                ...state,
                bestSellers: action.payload
            }
        case WEB_APP_THEME:
        return {
            ...state,
            theme: action.payload,
        };
        case CROSS_SELL:
            return {
                ...state,
                crossSellItems: action.payload
            }
        case "ORDER_DATA": {
            return {
                ...state,
                orderData: action.payload,
            };
        }
        case "ORDER_LIST": {
            return {
                ...state,
                orderList: action.payload,
            };
        }
        case "ORDER_DETAIL": {
            return {
                ...state,
                orderDetail: action.payload,
            };
        }
        case "REMOVE_ORDER_LIST": {
            return {
                ...state,
                orderList: [],
            };
        }
        case "LAST_FIVE_ORDERS": {
            return {
                ...state,
                lastFiveOrders: action.payload
            };
        }
        case "REMOVE_LAST_FIVE_ORDERS": {
            return {
                ...state,
                lastFiveOrders: [],
            };
        }
        case REMOVE_ORDER_DATA: {
            return {
                ...state,
                orderData: "",
            };
        }
        case COUPON_DETAILS: {
            return {
                ...state,
                couponDetails: action.payload
            }
        }
        case COUPON_FREE_DELIVERY: {
            return {
                ...state,
                couponFreeDelivery: action.payload
            }
        }

        default: return state;
    }
}
export default menuReducer;